/******************************************
*  Author : Riccardo Di Dato
*  Created On : Fri Jun 10 2022
*  File : BrowserLogger.ts
*******************************************/
import { NumericLogLevel } from "./Level.js";
/**
 * Classe di utility per logging.
 * La classe utilizza il logger della console del browser per mantenere l'associazione corretta con la riga del file sorgente.
 * Permette di inserire un prefisso ed un colore (usato solo per il prefisso).
 * Utilizza i livelli di logging di default del browser.
 *
 * @author Riccardo Di Dato
 */
export class BrowserLogger {
    /**
     * Stringa di prefisso
     *
     */
    prefix;
    /**
     * Colore del prefisso
     *
     */
    color;
    /**
     * Mai escluso in quanto livello di default
     */
    log;
    /**
     * Informazioni per debugging
     */
    debug;
    /**
     * Errori
     */
    error;
    /**
     * Informazioni da mostrare solo se si desidera un output più verboso
     */
    info;
    /**
     * Avvisi non bloccanti
     */
    warn;
    /**
     *
     * @param prefix Prefisso aggiunto ad ogni riga
     * @param color Colore del prefisso, default #000000
     * @param maxLevel Livello massimo da loggare, i log al di sotto di questo livello saranno ignorati
     */
    constructor(prefix, color = "#000000", maxLevel = NumericLogLevel.DEBUG) {
        this.prefix = '%c' + prefix;
        this.color = 'color: ' + color;
        if (typeof window !== "undefined") {
            if (maxLevel >= NumericLogLevel.LOG) {
                this.log = window.console.log.bind(window.console, this.prefix, this.color);
            }
            else {
                this.log = () => { };
            }
            if (maxLevel >= NumericLogLevel.DEBUG) {
                this.debug = window.console.debug.bind(window.console, this.prefix, this.color);
            }
            else {
                this.debug = () => { };
            }
            if (maxLevel >= NumericLogLevel.ERROR) {
                this.error = window.console.error.bind(window.console, this.prefix, this.color);
            }
            else {
                this.error = () => { };
            }
            if (maxLevel >= NumericLogLevel.INFO) {
                this.info = window.console.info.bind(window.console, this.prefix, this.color);
            }
            else {
                this.info = () => { };
            }
            if (maxLevel >= NumericLogLevel.WARN) {
                this.warn = window.console.warn.bind(window.console, this.prefix, this.color);
            }
            else {
                this.warn = () => { };
            }
        }
    }
}
